<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col md="6" lg="6" >
          <b-card
            header-tag="header"
            footer-tag="footer"
            >
           
            <div>
              <b-carousel id="carousel1"
                          style="text-shadow: 1px 1px 2px #333;"
                          controls
                          indicators
                          background="#ababab"
                          :interval="4000"
                          img-width="640"
                          img-height="300"
                          v-model="slide"
                          @sliding-start="onSlideStart"
                          @sliding-end="onSlideEnd"
                          
              >

                <!-- Text slides with image -->
                <!--
                <b-carousel-slide v-for="item in billboard" :key="item.id" :caption="item.caption"
                                  :text="item.text"
                                  :img-src="item.imgurl"
                >
              
              
                </b-carousel-slide>
                -->

                

                <b-carousel-slide v-for="item in billboard" :key="item.id" 
                >

                <template v-slot:img>
                  <img
                  class="d-block class-name"
                  width="300"
                  :src="item.imgurl"
                  alt="image slot">
                </template>

                </b-carousel-slide>
                
              </b-carousel>

              <!--
              <p class="mt-4">
                Slide #: {{ slide }}<br>
                Sliding: {{ sliding }}
              </p>
              -->

            </div>
          </b-card>
        </b-col>
        
      </b-row>

     
    </div>
  </div>
</template>

<!--
<style>
    .carousel-item img {
        max-width: fit-content;
        max-height:600px!important ;
    }
</style>
-->

<script>
export default {
  name: 'carousels',
  data () {
    return {
      
      slide: 0,
      sliding: null,
      billboard: [
        {
          id: 1,
          imgurl : "bmwagulhasnegras/billboard/bb221020_1045.png",
          caption : "",
          text : ""
        },
        {
          id: 2,
          imgurl : "bmwagulhasnegras/billboard/bb221108_1600.png",
          caption : "",
          text : ""
        }
        ,
        {
          id: 3,
          imgurl : "bmwagulhasnegras/billboard/bb220911_1053.png",
          caption : "",
          text : ""
        }
        ,
        {
          id: 4,
          imgurl : "bmwagulhasnegras/billboard/bb221021_1105.png",
          caption : "",
          text : ""
        }
        ,
        {
          id: 5,
          imgurl : "bmwagulhasnegras/billboard/bb221108_1700.png",
          caption : "",
          text : ""
        }
      ]
    }
  },
  methods: {
    onSlideStart (slide) {
      console.log('onSlideStart', slide)
      this.sliding = true
    },
    onSlideEnd (slide) {
      console.log('onSlideEnd', slide)
      this.sliding = false
    }
  }
}
</script>
